<template>
  <div class="pt-2">
    <!-- Allotments Table -->
    <div class="overflow-x-auto overflow-y-auto">
      <v-data-table
        :headers="headers"
        :items="allotments"
        :search="search"
        :loading="loading"
        class="table-radius border border-[#e0e0e0]"
        fixed-header
      >
        <!-- Headers Styling -->
        <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
          <p
            :key="'header-tool-' + index"
            class="font-title"
            v-if="header.text?.length > 15"
            v-tooltip="{ text: header.text }"
          >
            {{ header.text }}
          </p>
          <p :key="'header-text-' + index" v-else class="font-title">{{ header.text }}</p>
        </template>

        <!-- Row Data Styling -->
        <template v-slot:item.productId.productName="{ item }">
          <td class="px-4 py-3 table-font">
            {{ item.productId ? item.productId.productName : '' }}
          </td>
        </template>
        <template v-slot:item.locationId="{ item }">
          <td class="px-4 table-font">
            {{ item.locationId ? item.locationId.branchName : 'N/A' }}
          </td>
        </template>
        <template v-slot:item.acknowledged="{ item }">
          <td class="px-4 table-font">
            {{ item.acknowledged ? 'Acknowledged' : 'Not Acknowledged' }}
          </td>
        </template>
        <template v-slot:item.quantity="{ item }">
          <td class="px-4 table-font font-semibold">{{ item.quantity || 0 }}</td>
        </template>
        <template v-slot:item.stockStatus="{ item }">
          <td class="px-6 table-font">
            <span
              :class="[
                'px-4 py-1 rounded text-xs font-semibold uppercase',
                item.stockStatus === 'Available'
                  ? 'bg-green-100 text-green-700'
                  : 'bg-orange-100 text-orange-700'
              ]"
            >
              {{ item.stockStatus }}
            </span>
          </td>
        </template>
        <template v-slot:item.pendingQuantity="{ item }">
          <td class="px-4 table-font font-semibold">{{ item.pendingQuantity }}</td>
        </template>

        <template v-slot:item.action="{ item }">
          <td class="pl-4">
            <ActionButton
              :item="item"
              :canEdit="false"
              :canDelete="true"
              :handleEdit="() => openDialog(item)"
              :handleDelete="() => deleteItem(item)"
              :showEditButton="false"
              :showDeleteButton="true"
            />
          </td>
        </template>
      </v-data-table>
    </div>

    <!-- Dialog for Add/Edit -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card class="rounded-lg overflow-hidden p-2">
        <v-card-title class="bg-gray-50 border-b border-gray-200 px-6 py-4">
          <span class="text-lg font-bold text-[#21427d]">{{
            isEdit ? 'Edit Product Allocation' : 'Add Product Allocation'
          }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog" small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="px-6 py-8">
          <v-form ref="form" v-model="valid">
            <v-row dense>
              <v-col cols="12">
                <p class="text-sm font-semibold text-gray-700 mb-1">Product</p>
                <v-select
                  v-model="editedItem.productId"
                  :items="productOptions"
                  item-text="productName"
                  item-value="_id"
                  placeholder="Select Product"
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  :rules="[(v) => !!v || 'Product is required']"
                ></v-select>
              </v-col>

              <v-col cols="12">
                <p class="text-sm font-semibold text-gray-700 mb-1">Location</p>
                <v-select
                  v-model="editedItem.locationId"
                  :items="branchOptions"
                  item-text="branchName"
                  item-value="_id"
                  placeholder="Select Location"
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  :rules="[(v) => !!v || 'Location is required']"
                ></v-select>
              </v-col>

              <v-col cols="12">
                <p class="text-sm font-semibold text-gray-700 mb-1">Employee</p>
                <v-autocomplete
                  v-model="editedItem.userId"
                  :items="employeeOptions"
                  :item-text="
                    (item) => `${item.systemUserId?.firstName} ${item.systemUserId?.lastName || ''}`
                  "
                  item-value="_id"
                  placeholder="Select Employee"
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  clearable
                  :rules="[(v) => !!v || 'Employee is required']"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <p class="text-sm font-semibold text-gray-700 mb-1">Quantity</p>
                <v-text-field
                  v-model.number="editedItem.quantity"
                  type="number"
                  placeholder="Enter Quantity"
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  :rules="[(v) => !!v || 'Quantity is required', (v) => v > 0 || 'Must be > 0']"
                ></v-text-field>
              </v-col>

              <!-- <v-col cols="12">
                <p class="text-sm font-semibold text-gray-700 mb-1">Handover Date</p>
                <v-menu
                  v-model="handoverDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.handoverDate"
                      placeholder="Select Handover Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                      :rules="[(v) => !!v || 'Handover Date is required']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.handoverDate"
                    @input="handoverDateMenu = false"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col> -->
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 py-4 border-t border-gray-100 bg-gray-50">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeDialog" class="text-capitalize"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="px-8 white--text text-capitalize elevation-0"
            :disabled="!valid"
            :loading="saveLoading"
            @click="save"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ActionButton from '@/components/ActionButton.vue'

export default {
  name: 'AllotmentsTab',
  components: {
    ActionButton
  },
  props: {
    search: {
      type: String,
      default: ''
    },
    productOptions: {
      type: Array,
      default: () => []
    },
    branchOptions: {
      type: Array,
      default: () => []
    },
    locationId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      saveLoading: false,
      headers: [
        { text: 'Product', value: 'productId.productName', sortable: false },
        { text: 'Location', value: 'locationId', sortable: false },
        { text: 'Quantity', value: 'quantity', sortable: false },
        { text: 'Pending Quantity', value: 'pendingQuantity', sortable: false },
        { text: 'Acknowledged', value: 'acknowledged', sortable: false },
        { text: 'Status', value: 'stockStatus', sortable: false, align: 'center' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      allotments: [],
      employeeOptions: [],
      handoverDateMenu: false,
      editedItem: this.getDefaultItem(),
      defaultItem: this.getDefaultItem(),
      isEdit: false
    }
  },
  watch: {
    'editedItem.locationId': {
      async handler(newVal) {
        if (newVal) {
          await this.fetchEmployees(newVal)
        } else {
          this.employeeOptions = []
        }
      }
    },
    search(newVal) {
      this.fetchData()
    },
    locationId(newVal) {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    getDefaultItem() {
      return {
        _id: null,
        productId: null,
        locationId: null,
        userId: null,
        // handoverDate: new Date().toISOString().substr(0, 10),
        quantity: null
      }
    },
    async fetchData() {
      this.loading = true
      try {
        const params = {
          search: this.search || undefined,
          locationId: this.locationId || undefined
        }
        const res = await this.$axios.get('/inventory/product-allotments', { params })
        const items = res.data?.allotments || res.data?.data?.items || []
        this.allotments = Array.isArray(items) ? items : []
      } catch (e) {
        console.error('Error fetching allotments', e)
      } finally {
        this.loading = false
      }
    },
    async fetchEmployees(branchId) {
      try {
        const res = await this.$axios.get('/v3/users', {
          params: { branch: branchId, limit: 1000 }
        })
        this.employeeOptions = res.data?.users || []

        // Select first employee by default if adding new or if current userId doesn't exist in options
        if (this.employeeOptions.length > 0) {
          const currentUserId = this.editedItem.userId
          const exists = this.employeeOptions.some((e) => e._id === currentUserId)
          if (!exists || !currentUserId) {
            this.editedItem.userId = this.employeeOptions[0]._id
          }
        }
      } catch (e) {
        console.error('Error fetching employees', e)
        this.employeeOptions = []
      }
    },
    openDialog(item) {
      if (item) {
        this.isEdit = true
        this.editedItem = Object.assign({}, item)
        // Extract IDs for selects if they are objects
        if (item.productId && typeof item.productId === 'object') {
          this.editedItem.productId = item.productId._id
        }
        if (item.locationId && typeof item.locationId === 'object') {
          this.editedItem.locationId = item.locationId._id
          this.editedItem.acknowledged = false
        }
        if (item.userId && typeof item.userId === 'object') {
          this.editedItem.userId = item.userId._id
        }
        // if (item.handoverDate) {
        //   this.editedItem.handoverDate = item.handoverDate
        // }
      } else {
        this.isEdit = false
        this.editedItem = Object.assign({}, this.defaultItem)
      }
      this.dialog = true
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
    closeDialog() {
      this.dialog = false
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true
        try {
          const payload = { ...this.editedItem }
          await this.$axios.post('/inventory/product-allotments', payload)
          this.$toast.success('Product allocation saved')
          this.closeDialog()
          this.fetchData()
        } catch (e) {
          const msg = e.response?.data?.message || 'Failed to save allocation'
          this.$toast.error(msg)
        } finally {
          this.saveLoading = false
        }
      }
    },
    async deleteItem(item) {
      if (confirm('Are you sure you want to delete this allocation?')) {
        try {
          await this.$axios.delete(`/inventory/product-allotments/${item._id}`)
          this.$toast.success('Allocation deleted')
          this.fetchData()
        } catch (e) {
          const msg = e.response?.data?.message || 'Failed to delete allocation'
          this.$toast.error(msg)
        }
      }
    }
  }
}
</script>

<style scoped>
.table-radius {
  border-radius: 0px !important;
}
.font-title {
  font-size: 0.875rem;
  color: #000;
  margin-bottom: 0px !important;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table-font {
  font-size: 0.875rem;
  color: #374151;
}
</style>
